import { FC } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { twMerge } from 'tailwind-merge';

export interface Tab {
  name: string;
  id: string;
}

interface Props {
  tabs: Tab[];
  selectedTab: Tab;
  setSelectedTab: (newTab: Tab) => void;
  className?: string;
}

export const TabSelector: FC<Props> = ({ tabs, selectedTab, setSelectedTab, className }) => {
  const tabIndex = tabs.findIndex(t => t.id === selectedTab.id);
  if (tabIndex === -1) {
    throw Error('Invalid tab selected');
  }

  return (
    <div className={twMerge('flex items-center gap-5 border px-5 py-3 bg-white rounded-md', className)}>
      <button onClick={() => setSelectedTab(tabs[(tabIndex + tabs.length - 1) % tabs.length])}>
        <FiChevronLeft className="h-8 w-8" />
      </button>
      <div className="flex-1 text-center font-semibold text-lg">{selectedTab.name}</div>
      <button onClick={() => setSelectedTab(tabs[(tabIndex + 1) % tabs.length])}>
        <FiChevronRight className="h-8 w-8" />
      </button>
    </div>
  );
};
